"use client";

import {
  FacebookShareButton,
  FacebookIcon,
  WhatsappShareButton,
  WhatsappIcon,
  TwitterShareButton,
  TwitterIcon,
} from "next-share";

export default function BlogShareButtons({ url }) {
  return (
    <div className="blogsocialWrap mb-2">
      <h5>Share On: &nbsp;</h5>

      <FacebookShareButton url={url}>
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <WhatsappShareButton url={url}>
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>

      <TwitterShareButton url={url}>
        <TwitterIcon size={32} round />
      </TwitterShareButton>
    </div>
  );
}